<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">用户列表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:400px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户类型">
          <el-select v-model="formInline.type" clearable placeholder="请选择用户类型 " @change="handleQuery">
            <el-option v-for="(item, index) in $store.state.posts" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="formInline.name" clearable @blur="handleQuery" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="工号/学号">
          <el-input v-model="formInline.number" clearable @blur="handleQuery" placeholder="请输入工号/学号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button type="primary" @click="handleAdd()">新增用户</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载老师导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt @refresh="handleQuery" :action="action" :params="params" btnTitle="导入老师数据"></Importt>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile1">下载学生导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt @refresh="handleQuery" :action="action1" :params="params" btnTitle="导入学生数据"></Importt>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleBatchDel">批量删除</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleEditOrgan">批量修改组织结构</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%"
        @selection-change="handleSelectionChange(...arguments, 'id')">
        <custom-table-column type="selection" width="40">
        </custom-table-column>
        <custom-table-column fixed prop="name" width="100" label="姓名">
        </custom-table-column>
        <custom-table-column prop="username" width="160" label="工号/学号">
        </custom-table-column>
        <!-- <custom-table-column prop="number" width="160" label="工号">
        </custom-table-column> -->
        <!-- <custom-table-column prop="posts" label="职位">
        </custom-table-column> -->
        <!-- <custom-table-column prop="type" label="用户类型" width="120">
          <template slot-scope="scope">
            <span >{{ scope.row.usertype?userTypeObj[scope.row.usertype+'']:'' }}</span>
          </template>
</custom-table-column> -->
        <custom-table-column prop="usertype_str" label="用户类型" width="120">
        </custom-table-column>
        <custom-table-column label="组织结构" min-width="220">
          <template slot-scope="scope">
            <span v-html="formatter(scope.row)"></span>
          </template>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="244">
          <template slot-scope="scope">
            <el-button @click="handleOrgan(scope.row)"
              v-if="scope.row.usertype != 1 || $store.state.userInfo.usertype == 1" type="text"
              size="small">分配组织结构</el-button>
            <el-button @click="handleEditNew(scope.row)" v-if="scope.row.usertype != 1" type="text"
              size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" v-if="scope.row.usertype != 1" type="text"
              size="small">删除</el-button>
            <el-button @click="handleReset(scope.row.id)"
              v-if="scope.row.usertype != 1 || $store.state.userInfo.usertype == 1" type="text"
              size="small">重置密码</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入姓名" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="工号/学号" prop="username">
          <el-input v-model="ruleForm.username" placeholder="请输入工号/学号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="用户类型" prop="usertype">
          <el-select v-model="ruleForm.usertype" style="width:216px;" placeholder="请选择用户类型">
            <el-option v-for="(item, index) in $store.state.posts" :key="index" :label="item.label"
              :value="item.value+''"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="密码" prop="password">
          <el-input v-model="ruleForm.password" placeholder="请输入密码" style="width:216px;"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="工号/学号" prop="number">
          <el-input v-model="ruleForm.number" placeholder="请输入工号/学号" style="width:216px;"></el-input>
        </el-form-item> -->
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'" @click="submitFormByFun('ruleForm', creatUser)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateUser)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>{{ delText }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="组织结构" :visible.sync="organDialogVisible" width="560px">
      <el-scrollbar style="height:400px;">
        <el-tree :data="treeData" node-key="id" ref="tree" :check-strictly="true" :expand-on-click-node="true"
          show-checkbox :default-expanded-keys="[1]" :default-checked-keys="checkKeys" :props="defaultProps">
        </el-tree>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindOrgan">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';


export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinImport],
  data() {
    return {
      classRooms: [],
      levell: [1, 2, 3],
      organLabel: '',
      checkKeys: [],
      defaultProps: {
        children: 'sub',
        label: 'name',
      },
      formInline: {
        name: '',
        type: '',
        number: '',
        structure_1: '',
        major: '',
        class_name: '',
      },
      ruleForm: {
        name: '',
        username: '',
        // password: '',
        usertype: '',
        // number: '',
      },
      treeData: '',
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        username: [{ required: true, message: '请输入工号/学号', trigger: 'blur' }],
        // number: [{ required: true, message: '请输入工号/学号', trigger: 'blur' }],
        // password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        usertype: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
      },
      organDialogVisible: false,
      type: 'add',
      tableName: '实训日志',
      uid: '',
      action: '',
      action1: '',
      downloadUrl: 'template/老师导入模版.xlsx',
      downloadUrl1: 'template/学生导入模版.xlsx',
      downloadName: '用户导入模版.xlsx',
      userTypeObj: {}
    };
  },
  created() {
    this.action = `${this.baseUrlt}api/teacher/import`;
    this.action1 = `${this.baseUrlt}api/student/import`;
    this.$store.dispatch('getPosts');
  },
  mounted() {
    // this.getList();
    this.getTree();
  },
  watch: {
    '$store.state.posts': {
      handler: function (val) {
        this.$store.state.posts.map(item => {
          this.userTypeObj[item.value] = item.label
        })
      },
      deep: false,
    },
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    formatter(row) {
      let slist = row.structureList;
      if (slist && slist.length) {
        slist = slist.map((item) => {
          return item.structure_text;
        });
      }
      return slist.join('<br/>');
      // console.log(row, column)
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },
    handleEditOrgan() {
      if (this.multipleSelection.length) {
        this.organDialogVisible = true;
        this.uid = this.multipleSelection.join(',');
        this.setCheckedKeys([]);
      } else {
        this.$message({
          type: 'warning',
          center: true,
          message: '至少选择一条数据！',
        });
      }
    },
    handleReset(id) {
      this.confirmBox('warning', `此操作将重置该用户密码，是否继续`, { id }, this.deleteItem);
    },
    async deleteItem(params) {
      let res = await this.$api.instance.interfaceServer(`api/user/resetpsw`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '重置成功！',
        });
      }
    },
    handleOrgan(row) {
      this.organDialogVisible = true;
      this.uid = row.id;
      let slist = row.structureList;
      if (slist && slist.length) {
        slist = slist.map((item) => {
          return item.id;
        });
      }
      this.setCheckedKeys(slist);
    },
    setCheckedKeys(keys) {
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(keys);
      });
    },
    async bindOrgan() {
      let organKeys = this.$refs.tree.getCheckedKeys();
      if (!organKeys) {
        this.$message.warning('请先选择组织结构！');
      }
      let params = {
        uid: this.uid,
        structure_id: organKeys,
      };
      // console.log(params);
      // return;
      let res = await this.$api.update.bindOrgan(params);
      if (res.code == 0 && res.data) {
        this.organDialogVisible = false;
        this.$message.success('绑定成功！');
        this.resetChecked();
        this.getList();
      }
    },
    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },
    async getTree() {
      let res = await this.$api.instance.getOrgans();
      if (res.code == 0 && res.data) {
        this.treeData = res.data.map((item) => {
          if (!item.id) {
            item.id = 1;
          }
          return item;
        });
      }
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteUser(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.getList();
      }
    },
    async creatUser() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      // if (params.lesson_time) {
      //   let timee = params.lesson_time.getTime() / 1000;
      //   params.lesson_time = this.$until.getTimeStr(timee, '-');
      // }
      let res = await this.$api.creat.creatUser(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateUser() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      // console.log(params)
      // return
      let res = await this.$api.update.updateUser(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleQuery() {
      this.beforeQueryByKeyNew();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getUsers(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },

    downloadFile1() {
      const url = this.downloadUrl1;
      const link = document.createElement('a');
      // let fname = this.downloadName;
      link.href = this.downUrl + url;
      console.log(this.downUrl + url)
      // link.setAttribute('download', fname);
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
